var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 124,
    viewBox: "0 0 215 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.42 86.7695C213.79 100.9 201.85 111.82 187.73 111.19",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6179 0.00234413L37.9971 4.40234L42.3971 12.0231L50.0179 7.62314L45.6179 0.00234413Z",
    fill: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0431 81.0963L20.9463 79.4912L19.3412 83.5881L23.438 85.1932L25.0431 81.0963Z",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2204 86.6798L65.7204 82.7998L65.1104 89.4998L71.2204 86.6798Z",
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.8 46.9604C153.623 46.9604 155.1 45.4829 155.1 43.6604C155.1 41.8378 153.623 40.3604 151.8 40.3604C149.977 40.3604 148.5 41.8378 148.5 43.6604C148.5 45.4829 149.977 46.9604 151.8 46.9604Z",
    fill: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8196 118.51C78.6315 118.51 79.2896 117.852 79.2896 117.04C79.2896 116.228 78.6315 115.57 77.8196 115.57C77.0078 115.57 76.3496 116.228 76.3496 117.04C76.3496 117.852 77.0078 118.51 77.8196 118.51Z",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2898 61.6694C22.1764 61.6694 28.5698 55.276 28.5698 47.3894C28.5698 39.5027 22.1764 33.1094 14.2898 33.1094C6.40314 33.1094 0.00976562 39.5027 0.00976562 47.3894C0.00976562 55.276 6.40314 61.6694 14.2898 61.6694Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0202 59.8198C22.9069 59.8198 29.3002 53.4264 29.3002 45.5398C29.3002 37.6531 22.9069 31.2598 15.0202 31.2598C7.13361 31.2598 0.740234 37.6531 0.740234 45.5398C0.740234 53.4264 7.13361 59.8198 15.0202 59.8198Z",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0098 48.9402C14.1798 51.8402 19.8998 50.8202 22.7998 46.6602",
    stroke: "#FA5252",
    strokeWidth: 1.2524,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54004 36.5L8.57004 38.88L12.25 37.74L10.92 41.36L13.14 44.51L9.29004 44.36L6.98004 47.44L5.94004 43.74L2.29004 42.49L5.49004 40.35L5.54004 36.5Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2002 35.3496L18.9802 34.6296L20.5302 31.0996L22.3902 34.4696L26.2302 34.8496L23.5902 37.6596L24.4202 41.4296L20.9302 39.7896L17.6002 41.7396L18.0802 37.9096L15.2002 35.3496Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.49 54.58L128.86 64.6V31.79L111.22 41.97",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.49 67.14H59.6602C56.9002 67.14 54.6602 64.9 54.6602 62.14V34.25C54.6602 31.49 56.9002 29.25 59.6602 29.25H106.49C109.25 29.25 111.49 31.49 111.49 34.25V62.13C111.49 64.9 109.25 67.14 106.49 67.14Z",
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4406 29.2504C76.5434 29.2504 81.4906 24.3031 81.4906 18.2004C81.4906 12.0976 76.5434 7.15039 70.4406 7.15039C64.3379 7.15039 59.3906 12.0976 59.3906 18.2004C59.3906 24.3031 64.3379 29.2504 70.4406 29.2504Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4411 24.5209C73.9315 24.5209 76.7611 21.6913 76.7611 18.2009C76.7611 14.7104 73.9315 11.8809 70.4411 11.8809C66.9507 11.8809 64.1211 14.7104 64.1211 18.2009C64.1211 21.6913 66.9507 24.5209 70.4411 24.5209Z",
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1203 29.2504C100.223 29.2504 105.17 24.3031 105.17 18.2004C105.17 12.0976 100.223 7.15039 94.1203 7.15039C88.0176 7.15039 83.0703 12.0976 83.0703 18.2004C83.0703 24.3031 88.0176 29.2504 94.1203 29.2504Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1208 24.5209C97.6112 24.5209 100.441 21.6913 100.441 18.2009C100.441 14.7104 97.6112 11.8809 94.1208 11.8809C90.6303 11.8809 87.8008 14.7104 87.8008 18.2009C87.8008 21.6913 90.6303 24.5209 94.1208 24.5209Z",
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.18 35.5605H90.9697V45.0305H105.18V35.5605Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1299 56.0908H83.0699",
    stroke: "#F03E3E",
    strokeWidth: 1.2524,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1299 49.7705H83.0699",
    stroke: "#F03E3E",
    strokeWidth: 1.2524,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.32 92.5599C146.58 91.7399 149.6 91.3499 153.39 92.3399C162.68 94.7699 171.26 87.6299 171.26 87.6299L174.75 97.4599C174.75 97.4599 162.8 105.22 155.38 102.5C151.5 101.08 147.42 101.91 144.41 103.03",
    fill: "#E03131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8599 95.5295C94.1699 81.1995 106.84 70.6495 121.17 71.9595C132.81 73.0195 141.96 81.5895 144.28 92.4495C144.82 94.9595 144.99 97.5795 144.74 100.27C144.66 101.17 144.53 102.05 144.36 102.91C141.84 115.87 129.86 125.07 116.42 123.84C102.1 122.54 91.5499 109.86 92.8599 95.5295Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.8 119.21C130.569 119.21 140.11 109.669 140.11 97.8998C140.11 86.1307 130.569 76.5898 118.8 76.5898C107.031 76.5898 97.4902 86.1307 97.4902 97.8998C97.4902 109.669 107.031 119.21 118.8 119.21Z",
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.789 104C111.711 104 114.889 100.821 114.889 96.8998C114.889 92.9786 111.711 89.7998 107.789 89.7998C103.868 89.7998 100.689 92.9786 100.689 96.8998C100.689 100.821 103.868 104 107.789 104Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.8 106.01C133.721 106.01 136.9 102.831 136.9 98.9096C136.9 94.9884 133.721 91.8096 129.8 91.8096C125.879 91.8096 122.7 94.9884 122.7 98.9096C122.7 102.831 125.879 106.01 129.8 106.01Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.95 92.4197C123.871 92.4197 127.05 89.2409 127.05 85.3197C127.05 81.3985 123.871 78.2197 119.95 78.2197C116.028 78.2197 112.85 81.3985 112.85 85.3197C112.85 89.2409 116.028 92.4197 119.95 92.4197Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.65 117.58C121.571 117.58 124.75 114.401 124.75 110.48C124.75 106.559 121.571 103.38 117.65 103.38C113.729 103.38 110.55 106.559 110.55 110.48C110.55 114.401 113.729 117.58 117.65 117.58Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53 99.9199L149.39 101.49",
    stroke: "#FA5252",
    strokeWidth: 1.2524,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.82 100.489L155.67 102.059",
    stroke: "#FA5252",
    strokeWidth: 1.2524,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.68 98.4893L168.54 100.069",
    stroke: "#FA5252",
    strokeWidth: 1.2524,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.25 99.4893L161.96 102.639",
    stroke: "#FA5252",
    strokeWidth: 1.2524,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.21 67.4105C183.301 67.4105 189.05 61.6618 189.05 54.5705C189.05 47.4791 183.301 41.7305 176.21 41.7305C169.119 41.7305 163.37 47.4791 163.37 54.5705C163.37 61.6618 169.119 67.4105 176.21 67.4105Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.2 54.3804V46.6504L178.89 50.5104L185.57 54.3804L178.89 58.2404L172.2 62.1004V54.3804Z",
    fill: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5596 111.68L53.1296 91.6396",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37988 5.87988L36.9499 25.9199",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.65 3.37012L148.41 19.6601",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.87988 106.07L43.2099 88.54",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLeftImage);
export default __webpack_public_path__ + "static/media/videoLeftImage.ec02b3b86dac9a7309b818fce1a32529.svg";
export { ForwardRef as ReactComponent };